import { axios } from './config';

export const getAllPlaylistMappings = (ownerEmail) => {
	return axios.get(`/cb/contentMapping/playlist-all?ownerEmail=${encodeURIComponent(ownerEmail)}`);
};

export const getPlaylistMapping = (playlistId) => {
	return axios.get(`/cb/contentMapping/playlist-mapping/${playlistId}`);
};

export const createPlaylistMapping = (mappingPayload) => {
	return axios.post('/cb/contentMapping/create-playlist-mapping/', mappingPayload);
};

export const updatePlaylistMapping = (mappingPayload) => {
	const { playlistId, processStatus } = mappingPayload.data;
	return axios.put(
		`/cb/contentMapping/update-playlist-mapping?playlistId=${playlistId}&status=${processStatus}/`,
		mappingPayload
	);
};

export const getCummulativePlaylistsForSite = (siteId) => {
	return axios.get(`/cb/contentMapping/site-playlists/${siteId}`);
};

export const remapPlaylist = (playlistId) => {
	return axios.get(`/cb/contentMapping/remap-playlist?playlistId=${playlistId}`);
};
